/**
 * O SDK do Cognito (Amplify) lança erros com mensagens padrão em inglês
 * (`error.message`), que nunca devem chegar cruas à interface. Este mapa
 * traduz os nomes de exceção mais comuns para PT-BR; qualquer erro não
 * mapeado usa a mensagem de fallback fornecida pelo chamador, nunca o
 * `error.message` original do SDK.
 */
const AUTH_ERROR_MESSAGES: Record<string, string> = {
  NotAuthorizedException: "Usuário ou senha incorretos.",
  UserNotFoundException: "Usuário não encontrado.",
  UserNotConfirmedException: "Conta ainda não confirmada. Verifique seu e-mail.",
  PasswordResetRequiredException:
    "É necessário redefinir sua senha antes de continuar.",
  TooManyRequestsException:
    "Muitas tentativas. Aguarde alguns minutos e tente novamente.",
  TooManyFailedAttemptsException:
    "Muitas tentativas. Aguarde alguns minutos e tente novamente.",
  LimitExceededException:
    "Muitas tentativas. Aguarde alguns minutos e tente novamente.",
  InvalidParameterException:
    "Dados inválidos. Verifique as informações e tente novamente.",
  CodeMismatchException:
    "Código inválido. Verifique o código enviado por e-mail.",
  ExpiredCodeException:
    "Código expirado. Solicite um novo código e tente novamente.",
  InvalidPasswordException: "A senha não atende aos requisitos mínimos.",
  UsernameExistsException: "Já existe uma conta com este usuário ou e-mail.",
  NetworkError: "Falha de conexão. Verifique sua internet e tente novamente.",
};

export function translateAuthError(error: unknown, fallback: string): string {
  const identifier =
    (error as { name?: string; code?: string } | null | undefined)?.name ||
    (error as { name?: string; code?: string } | null | undefined)?.code ||
    "";
  return AUTH_ERROR_MESSAGES[identifier] || fallback;
}
